export default __webpack_public_path__ + "static/media/periodclose-12.89019333.svg";